import React, { createContext, useContext, useMemo } from 'react';
import { getTemplateColors, makeBaseStyles, FONT } from './styles';

// Context que propaga los colores del tenant a todas las sections del
// TemplateEngine. Incluye tambien `baseStyles` memoizado (StyleSheet de
// @react-pdf) para que cada section lo reuse sin recrearlo.

const TemplateColorsContext = createContext({
  colors: getTemplateColors(),
  baseStyles: makeBaseStyles(getTemplateColors()),
  FONT,
});

export const TemplateColorsProvider = ({ colors, children }) => {
  const value = useMemo(() => {
    const resolved = getTemplateColors(colors || {});
    return {
      colors: resolved,
      baseStyles: makeBaseStyles(resolved),
      FONT,
    };
  }, [colors?.primary, colors?.secondary]);

  return <TemplateColorsContext.Provider value={value}>{children}</TemplateColorsContext.Provider>;
};

export const useTemplateColors = () => useContext(TemplateColorsContext);
